import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UtmService {
  private keys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid'
  ];

  capture(params: any) {
    this.keys.forEach(key => {
      const value = params[key];

      // FIRST TOUCH (do not overwrite)
      // if (value && !localStorage.getItem(key)) {
      if (value) {
        localStorage.setItem(key, value);
      }

      // LAST TOUCH (optional)
      if (value) {
        localStorage.setItem('last_' + key, value);
      }
    });

    // fallback
    if (!localStorage.getItem('utm_source')) {
      localStorage.setItem('utm_source', 'organic');
    }

    if (!localStorage.getItem('landing_page')) {
      localStorage.setItem('landing_page', window.location.href);
    }

    if (!localStorage.getItem('referrer')) {
      localStorage.setItem('referrer', document.referrer);
    }
  }

  getFirstTouch() {
    return this.mapKeys('');
  }

  getLastTouch() {
    return this.mapKeys('last_');
  }

  private mapKeys(prefix: string) {
    const data: any = {};
    this.keys.forEach(k => {
      data[k] = localStorage.getItem(prefix + k);
    });
    return data;
  }

  clear() {
    [...this.keys, ...this.keys.map(k => 'last_' + k)]
      .forEach(k => localStorage.removeItem(k));
  }
}